import { DataGrid } from "@mui/x-data-grid";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../firebase";
import { userColumns } from "./datatablesource";
import { Typography } from "@mui/material";

const Datatable = () => {
  const [data, setData] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const uid = queryParams.get("uid");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const paymentsRef = collection(db, "withdraw_request");
        let q = query(paymentsRef);

        if (uid) {
          q = query(paymentsRef, where("user_id", "==", uid));
        }

        const unsubscribe = onSnapshot(q, (snapshot) => {
          const list = [];
          snapshot.forEach((doc) => {
            const data = doc.data();
            list.push({
              id: doc.id,
              phone: data.phone,
              timestamp: data.timestamp,
              userImage: data.userImage || "",
              description: data.description || "",
              email: data.email || "",
              amount: data.amount || "",
              user_id: data.user_id || "",
              status: data.status || "",
            });
          });
          setData(list);
        });

        return unsubscribe; // Return the unsubscribe function
      } catch (error) {
        console.error("Error fetching payments:", error);
      }
    };

    fetchData();

    // Cleanup function
    return () => {}; // No cleanup needed if unsubscribe is handled in fetchData

  }, [uid]); // Dependency on uid ensures useEffect runs whenever uid changes

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => (
        <div className="cellAction">
          <Link
            to={`/paymentrequest/fullview?uid=${params.row.id}`}
            style={{ textDecoration: "none" }}
          >
            <div className="viewButton">View</div>
          </Link>
        </div>
      ),
    },
  ];

  return (
    <div className="datatable">
      {uid && (
        <Typography variant="body" component="h4" gutterBottom>
          WITHDRAW REQUEST || User ID: {uid}
        </Typography>
      )}
      <DataGrid
        className="datagrid"
        rows={data}
        columns={[...userColumns, ...actionColumn]}
        pageSize={9}
        rowsPerPageOptions={[9]}
        checkboxSelection
      />
    </div>
  );
};

export default Datatable;
